// extracted by mini-css-extract-plugin
export default {"about_container":"About_about_container__rriI5"};